import { render, staticRenderFns } from "./HomeworkNoteImage.vue?vue&type=template&id=bbaa562c&scoped=true"
import script from "./HomeworkNoteImage.vue?vue&type=script&lang=js"
export * from "./HomeworkNoteImage.vue?vue&type=script&lang=js"
import style0 from "./HomeworkNoteImage.vue?vue&type=style&index=0&id=bbaa562c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaa562c",
  null
  
)

export default component.exports